export enum SuffixType {
  Text = 'text',
  Img = 'img',
}
export enum InputType {
  Text = 'text',
  Password = 'password',
}

export enum AutoCompleteType {
  NAME = 'name',
  EMAIL = 'email',
  PAYMENT_METHOD = 'cc-name',
  ON = 'on',
  OFF = 'off',
}

export enum FormsIds {
  NAME = 'name',
  EMAIL = 'email',
  PASSWORD = 'password',
}
